import Vue from 'vue';

Vue.filter('asTime', (time) => time.format('DD.MM.YYYY HH:mm'));
